import React from 'react';
import { List } from '@mui/material';
import { useLocation } from 'react-router-dom';
import AppBarTest from './AppBarTest';
import ToastAlert from '../ToastAlert/ToastAlert';

export default function Layout({ children }) {
	const location = useLocation();

	return (
		<>
			<AppBarTest>
				{location.pathname === '/' ? (
					<List disablePadding>{children}</List>
				) : (
					<>{children}</>
				)}
				<ToastAlert />
			</AppBarTest>
		</>
	);
}
